'use client';

import { useTranslations } from 'next-intl';

import { Box, Grid, Typography } from '@mui/material';

import { PageSelector } from '../../components/pageSelector/PageSelector';
import { InfoBox } from '../../components/infoBox/InfoBox';
import { APP_PARTNER_FULL_NAME } from '../../../../../../configs/app.config';
import { Markdown } from '../../../../../../components/markdown/Markdown';

const StartView = () => {
  const t = useTranslations();

  return (
    <Box>
      <Typography component="h1" variant="h4" textAlign="center" sx={{ mb: 4 }}>
        {t('headers.header', { company: APP_PARTNER_FULL_NAME })}
      </Typography>
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Markdown>{t('text.desc')}</Markdown>
      </Box>
      <Grid
        container
        spacing={2}
        direction="row"
        sx={{
          justifyContent: 'center',
          alignItems: 'stretch',
        }}
      >
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <InfoBox />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <PageSelector />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StartView;
